/** Rótulo y clase de badge por severidad — compartido entre `AlertsPage.tsx`
 *  (la tabla/tarjetas completas) y cualquier vista compacta que muestre
 *  alertas sueltas (ej. el feed del panel de `/bots`), para que las dos no
 *  terminen pintando la misma severidad con colores distintos. */
import type { AlertSeverity } from '../api/types'

export const ALERT_SEVERITY_LABEL: Record<AlertSeverity, string> = {
  critical: 'Crítica',
  warning: 'Aviso',
  info: 'Info',
}

export const ALERT_SEVERITY_CLASS: Record<AlertSeverity, string> = {
  critical: 'badge badge--error',
  warning: 'badge badge--warning',
  info: 'badge',
}
